/**
 * @fileoverview Provides the `PrivateRoute` component, which uses the `useAuth` hook (implicitly via `user` and `loading` props) to protect routes. It redirects unauthenticated users to the sign-in page and renders the `Outlet` for authenticated users, handling loading states.
 */

import type { User } from 'firebase/auth'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

export function PrivateRoute({ user, loading }: { user: User | null; loading: boolean }) {
  const location = useLocation()

  // Show loading state while authentication state is being determined
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    )
  }

  // If not logged in, redirect to login page
  if (!user) {
    // Remember the page they tried to access for redirecting after login
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // If logged in, render the child routes
  return <Outlet />
}
